import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/FurEver.Access`],
};

export const graphScopes = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'GroupMember.Read.All'],
};

export const ADMIN_GROUP_ID = '317425d5-5ecf-4816-928c-2a0899c6dfa5';
